<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>返金方法登録</mat-card-title>
    </mat-card-header>
    <form (ngSubmit)="onRegist()" [formGroup]="refundReqInfDto">
        <mat-card-content>
            <div [formGroup]="repayReqInfo">
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field [appearance]="getAppearance('repayMny')"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>返金額</mat-label>
                        <input matInput formControlName="repayMny" class="font-color-display-only text-right"
                            autocomplete="off" [value]="repayReqInfo.get('repayMny').value | number" />
                        <span matSuffix>円</span>
                    </mat-form-field>
                </div>
                <h2>返金先口座情報</h2>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field [appearance]="getAppearance('rpaytokouzaRepaywayCode')"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>返金方法</mat-label>
                        <mat-select formControlName="rpaytokouzaRepaywayCode"
                            (selectionChange)="onChangeSelect($event.value)" class="font-color-display-only">
                            <mat-option *ngFor="let type of repayMethodList" [value]="type.value">{{type.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field [appearance]="getAppearance('kohuriActknj')"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>口座名義（漢字）</mat-label>
                        <input matInput formControlName="kohuriActknj" autocomplete="off" minlength="1" maxlength="24"
                            class="font-color-display-only" />
                    </mat-form-field>
                    <mat-form-field [appearance]="getAppearance('kouzaMeigiKana')"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>口座名義（カナ）</mat-label>
                        <input matInput formControlName="kouzaMeigiKana" autocomplete="off" minlength="1" maxlength="30"
                            class="font-color-display-only" />
                    </mat-form-field>
                </div>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field [appearance]="getAppearance('extBankfcCode')"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>金融機関コード</mat-label>
                        <input matInput formControlName="extBankfcCode" autocomplete="off" minlength="4" maxlength="4"
                            class="font-color-display-only" (input)="onInputBankfcAname($event)" />
                    </mat-form-field>
                    <mat-form-field [appearance]="getAppearance('extBranchCode')"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>支店コード</mat-label>
                        <input matInput formControlName="extBranchCode" autocomplete="off" minlength="3" maxlength="3"
                            class="font-color-display-only" (input)="onInputBranchAname($event)" />
                    </mat-form-field>
                </div>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field [appearance]="'fill'"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>金融機関名</mat-label>
                        <input matInput id="bankfcAname" [value]="bankfcAname" class="font-color-display-only"
                            readonly="true" disabled />
                    </mat-form-field>
                    <mat-form-field [appearance]="'fill'"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>支店名</mat-label>
                        <input matInput id="branchAname" readonly="true" [value]="branchAname"
                            class="font-color-display-only" disabled />
                    </mat-form-field>
                </div>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field [appearance]="getAppearance('kouzaDptclsDivcd')"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>預金種別</mat-label>
                        <mat-select formControlName="kouzaDptclsDivcd" class="font-color-display-only">
                            <mat-option *ngFor="let type of kouzayokinSyubetuList"
                                [value]="type.value">{{type.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field [appearance]="getAppearance('kouzaNo')"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>口座番号</mat-label>
                        <input matInput formControlName="kouzaNo" autocomplete="off" maxlength="7" minlength="7"
                            class="font-color-display-only" />
                    </mat-form-field>
                </div>

                <h2>返金元口座情報</h2>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field [appearance]="getAppearance('refundsourceKouzaCode')"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>返金元口座設定</mat-label>
                        <mat-select formControlName="refundsourceKouzaCode" class="font-color-display-only">
                            <mat-option *ngFor="let type of henkinmotoKouzaList" [value]="type.value">{{type.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center"
                    *ngIf="hyojiCndtFlg">
                    <mat-card-actions class="btn_area_right">
                        <button type="submit" mat-raised-button color="primary" class="btn"
                            [disabled]="repayReqInfo.invalid">登録</button>
                    </mat-card-actions>
                </div>
                <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center"
                    *ngIf="!hyojiCndtFlg">
                    <mat-dialog-actions class="btn_area_right">
                        <button type="button" mat-raised-button color="primary" class="btn"
                            (click)="onClickModalClose()">
                            閉じる
                        </button>
                    </mat-dialog-actions>
                </div>
            </div>
        </mat-card-content>
    </form>
</mat-card>